module.exports = require('linkifyjs/lib/linkify-string');
